import React, { useContext, useState, useRef, useEffect } from "react";
import { Button, Col } from "react-bootstrap";
import { Input } from "../../components/Form";
import { ToastContext } from "../../contexts/toast/toastContext";

import { Form } from "@unform/web";
import { SubmitHandler, FormHandles } from "@unform/core";
import getValidationErrors from "../../helpers/getValidateErrors";

import * as Yup from "yup";
import { IMinhaContaList, IMinhaContaForm } from "../../common/interfaces/minhaConta.interfaces";
import api from "../../services/api";
import { getSingleErrorMessage } from "../../helpers/getSingleErrorMessage";

const MinhaConta: React.FC = () => {
  // Refs
  const formRef = useRef<FormHandles>(null);

  //Context
  const toastContext = useContext(ToastContext);

  //States
  const [usuario, setUsuario] = useState<IMinhaContaList>({} as IMinhaContaList);

  useEffect(() => {
    (async () => {
      const { data } = await api.get('usuario/minhaConta');
      setUsuario(data);
    })();
  }, []);

  // Handles
  const handleSave = () => {
    formRef.current?.submitForm();
  };

  const handleSubmit: SubmitHandler = async (minhaConta: IMinhaContaForm, { reset }) => {
    try {
      formRef.current?.setErrors({});

      const message = "Campo obrigatório";
      const schema = Yup.object().shape({
        senhaAtual: Yup.string().required(message),
        novaSenha: Yup.string()
          .matches(
            /^(?=.*?[a-z])/,
            "A senha precisa ter pelo menos uma letra."
          )
          .matches(
            /^(?=.*?[0-9])/,
            "A senha precisa ter pelo menos um número."
          )
          .min(6, 'A senha precisa ter no mínimo 6 caracteres.')
          .required(message),
        confirmarNovaSenha: Yup.string().required(message)
          .oneOf([Yup.ref('novaSenha'), null], 'Senha não confere. Digite a mesma senha nos dois campos.')
      });
      await schema.validate(minhaConta, { abortEarly: false });

      await api.post('conta/alterar-senha', minhaConta);
      reset();
      toastContext.notification("A ação foi concluída.", "success");
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        formRef.current?.setErrors(getValidationErrors(err));
      }
      else {
        toastContext.notification(getSingleErrorMessage(err), "error");
      }
    }
  };

  return (
    <>
      <div className="content py-3">
        <div className="container-xl mb-3">
          <div className="page-header">
            <div className="row">
              <h1>Minha Conta</h1>
              <span className="col-auto ml-auto pr-0">

              </span>
            </div>
          </div>
          <div className="row">
          <div className="card p-3" style={{justifyContent:"center", alignItems:"center"}}>
            <Col xl={4} lg={5} md={6} sm={6} xs={12}>
              <div className="card-body">
                <div className="text-center">
                  <div className="mt-3">
                    <span className="badge bg-green-lt">{usuario.tipo}</span>
                  </div>
                </div>
                <Form className="mt-4" ref={formRef} onSubmit={handleSubmit}>
                  <div className="form-row d-block">
                    <div className="form-group">
                      <label className="form-label">Senha Atual</label>
                      <Input
                        type="password"
                        name="senhaAtual"
                        className="form-control"
                        placeholder="Senha Atual..."
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Nova Senha</label>
                      <Input
                        type="password"
                        name="novaSenha"
                        className="form-control"
                        placeholder="Nova Senha..."
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Confirmar Nova Senha</label>
                      <Input
                        type="password"
                        name="confirmarNovaSenha"
                        className="form-control"
                        placeholder="Confirmar Nova Senha..."
                      />
                    </div>
                    <div className="form-group float-right">
                      <label className="form-label">&nbsp;</label>
                      <Button variant="btn btn-primary" onClick={handleSave}>
                        Alterar Senha
                        <i className="fa fa-unlock-alt ml-2" aria-hidden="true"></i>
                      </Button>
                    </div>
                    <div className="mt-5 text-center">
                        <label className="ml-3">
                          Sua senha deve ter no mínimo 6 caracteres entre letras números.
                        </label>
                    </div>
                  </div> 
                </Form>
              </div>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MinhaConta;
